<template>
  <div v-if="!isLoading">
    <div v-if="1 == 2">
      {{ formData }}
    </div>

    <vs-card>
      <!-- Botão voltar -->
      <div class="flex gap-4">
        <div class="lg:block">
          <vs-button @click="voltar" type="border">Voltar</vs-button>
        </div>

        <a
          v-if="formData.linkCertificadoAberturaEvento"
          target="_blank"
          :href="`${formData.linkCertificadoAberturaEvento}`"
        >
          <vs-button
            v-tooltip="'Aviso Sinistro Digital'"
            color="warning"
            type="gradient"
            icon-pack="feather"
            icon="icon-file-text"
            class="mr-3 mb-2 btn-print"
          >
            Aviso Sinistro Digital
          </vs-button>
        </a>
      </div>

      <CadastroPatrimonioForm :formData="formData" :dominios="dominios" />

      <DadosTerceiroForm
        :formData="formData"
        :dominios="dominios"
        title="Dados Proprietário Patrimônio"
      />

      <LocalEventoForm :formData="formData" />

      <ReparoDetalhesForm :formData="formData" :dominios="dominios" />

      <ProcessoDatasForm :formData="formData" :dominios="dominios" />

      <CustoEventoPatrimonioForm :formData="formData" />

      <FotosDocumentos
        :formData="formData"
        :arquivos="formData.arquivosTerceiros"
        :idReferente="idReferenteEvento"
      />
    </vs-card>

    <!-- Botões Voltar e Salvar -->
    <div class="flex lg:justify-between justify-end mb-4">
      <div class="lg:block">
        <vs-button @click="voltar">Voltar</vs-button>
      </div>

      <vs-button color="success" @click="submit()">
        Salvar Alterações
      </vs-button>
    </div>
  </div>
</template>

<script>
import notify from '../../../../utils/notify';
import service from '../../../../services';
import utilsLocal from './../utils';
import eventoService from './../shared/service';

import { FOTO_REFERENTE_PATRIMONIOS } from './../shared/const';

// Component
import CadastroPatrimonioForm from './components/CadastroPatrimonioForm.vue';
import CustoEventoPatrimonioForm from './components/CustoEventoPatrimonioForm.vue';
import DadosTerceiroForm from './../shared/components/DadosTerceiroForm.vue';
import FotosDocumentos from './../shared/components/FotosDocumentos.vue';
import ProcessoDatasForm from './../shared/components/ProcessoDatasForm.vue';
import ReparoDetalhesForm from './components/ReparoDetalhesForm.vue';
import LocalEventoForm from '../shared/components/LocalEventoForm.vue';

export default {
  components: {
    CadastroPatrimonioForm,
    CustoEventoPatrimonioForm,
    DadosTerceiroForm,
    FotosDocumentos,
    ProcessoDatasForm,
    ReparoDetalhesForm,
    LocalEventoForm,
  },
  data() {
    return {
      isLoading: true,
      idReferenteEvento: FOTO_REFERENTE_PATRIMONIOS,
      idStatusVerificacaoAlteracao: '',
      // Domínios
      dominios: {
        listSituacoes: [],
        listResponsaveis: [],
        listVistoriadores: [],
        listOficinas: [],
        listLocalizacaoDocumentos: [],
      },

      formData: {
        cadastroPatrimonio: {},
        dadosTerceiro: {},
        reparoVeiculo: {},
        processosDatas: {},
        arquivosTerceiros: [],
        custoEvento: {},
        boletimOcorrencia: {},
      },
    };
  },
  methods: {
    voltar() {
      this.$router.go(-1);
    },
    async getListDominios() {
      try {
        this.$vs.loading();

        const promises = [
          utilsLocal.bucarSituacoes(),
          eventoService.getListUsuarios(),
          eventoService.getListVistoriadores(),
          eventoService.getListOficinas(),
          eventoService.getListLocalizacaoDocumentacao(),
        ];

        const [
          listSituacoes,
          listResponsaveis,
          listVistoriadores,
          listOficinas,
          listLocalizacaoDocumentos,
        ] = await Promise.all(promises);

        listSituacoes.forEach((element) => {
          this.dominios.listSituacoes.push({
            id: element.idStatus,
            label: element.nomeStatus,
          });
        });

        this.dominios.listResponsaveis = listResponsaveis;
        this.dominios.listVistoriadores = listVistoriadores;
        this.dominios.listOficinas = listOficinas;
        this.dominios.listLocalizacaoDocumentos = listLocalizacaoDocumentos;
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async getPatrimonio() {
      const { idPatrimonio } = this.$route.params;

      if (!idPatrimonio) {
        return;
      }

      try {
        this.$vs.loading();

        const result = await service.getAll(
          'eventos-patrimonios',
          null,
          idPatrimonio,
        );
        const patrimonio = result.data;
        this.idStatusVerificacaoAlteracao =
          patrimonio.cadastroPatrimonio.idStatus;

        if (!patrimonio) {
          notify.notifyFail(
            this.$vs,
            'Você não tem acesso a visualização deste Patrimônio',
          );
          this.$vs.loading.close();
          return;
        }

        this.isLoading = false;

        this.$nextTick(() => {
          this.formData = patrimonio;
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    async submit() {
      try {
        this.$vs.loading();

        const idUsuarioSend = eventoService.getIdUsuario();
        const data = { ...this.formData, idUsuarioSend };

        const idStatusIsAltered =
          data.cadastroPatrimonio.idStatus !==
          this.idStatusVerificacaoAlteracao;
        if (idStatusIsAltered) {
          data.cadastroPatrimonio.idStatusUpdatedAt = new Date();
        }

        const dataPatrimonio = await service.post(
          'eventos-patrimonios',
          'update',
          data,
        );

        this.idStatusVerificacaoAlteracao = data.cadastroPatrimonio.idStatus;
        this.formData = dataPatrimonio.data;
        notify.notifySuccess(this.$vs, 'Patrimônio salvo com sucesso!');
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async mounted() {
    await this.getListDominios();
    await this.getPatrimonio();
  },
};
</script>
